import { HEALTH_CHECK } from './actionType';

export const healthCheck = (data) => {
  return { type: HEALTH_CHECK, payload: data };
};
